export const idealistOrganizationSchemaMarkup = JSON.stringify({
  '@context': 'https://schema.org/',
  '@type': 'Organization',
  name: 'Idealist',
  legalName: 'Idealist.org, Inc.',
  alternateName: ['VolunteerMatch', 'Action Without Borders'],
  url: 'https://www.idealist.org',
  logo: 'https://www.idealist.org/static/images/logos/logo-mark.webp',
  sameAs: [
    'https://x.com/idealist',
    'https://www.tiktok.com/@joinidealist',
    'https://www.linkedin.com/company/idealist.org',
    'https://www.instagram.com/joinidealist',
    'https://www.facebook.com/Idealist',
    'https://www.youtube.com/@idealist',
    'https://en.wikipedia.org/wiki/Action_Without_Borders',
    'https://www.crunchbase.com/organization/idealist-2',
    'https://www.linkedin.com/company/volunteermatch/',
    'https://www.youtube.com/@volunteermatch',
    'https://www.facebook.com/VolunteerMatch/',
    'https://x.com/VolunteerMatch',
  ],
});
